import { AfterViewInit, Component } from '@angular/core';
import { ColumnRendererComponentV3, TooltipOnEllipsisV2Directive } from '@gea/digital-ui-lib';
import { NgOptimizedImage } from '@angular/common';
import { Machine } from '../machines-table/machines-table.constants';
import { TooltipModule } from 'primeng/tooltip';
import { getPictogramAssetPath } from '@shared/utils/shared-helpers';
import { AssetProduct } from '@generated-apis/model/assetProduct';

@Component({
  selector: 'app-machine-dashboard-name-renderer',
  imports: [NgOptimizedImage, TooltipOnEllipsisV2Directive, TooltipModule],
  templateUrl: './machine-name-column-renderer.component.html',
  styleUrl: './machine-name-column-renderer.component.scss',
})
export class MachineNameColumnRendererComponent implements ColumnRendererComponentV3<any>, AfterViewInit {
  rowData: Partial<Machine> = {};
  pictogram: string = '';

  ngAfterViewInit() {
    this.pictogram = getPictogramAssetPath(<AssetProduct.MachineTypeEnum>this.rowData.machineType);
  }
}
